import { types } from 'mobx-state-tree'

export default types.model({
  description: '',
  cost: 0,
  isCostEdited: false
}).actions(self => ({
  setCost(cost) {
    self.cost = cost
    self.isCostEdited = true
  }
}))


// WEBPACK FOOTER //
// ./src/models/CalculatedAddtionalCost.js